import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';

class DimensionPanelState {
  store = new DomainStore();
  agent = null;

  dimension = {};
  editingDimensionValue = {};
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      agent: false
    });
  }

  receiveProps({dimension}) {
    this.dimension = dimension;
  }

  setAgent(agent) {
    this.agent = agent;
  }

  async saveDimensionValue() {
    const {model, errors} = this.editingDimensionValue.isNew ?
      await this.store.post(
        endpoints.TIME_TRACKING.DIMENSION_VALUES.FOR_DIMENSION(this.dimension.id),
        types.TIME_TRACKING.DIMENSION_VALUE,
        this.editingDimensionValue
      ) :
      await this.store.patch(this.editingDimensionValue);
    this.errors = errors;

    if (model) {
      this.closeEditDimensionValueModal();
      await this.agent.refresh();
    }
  }

  removeDimensionValue(dimensionValue) {
    return this.store.destroy(dimensionValue);
  }

  async archiveDimensionValue() {
    const {model} = await this.store.post(
      this.editingDimensionValue.link('archive'),
      types.TIME_TRACKING.DIMENSION_VALUE
    );

    if (model) {
      this.closeArchiveDimensionValueModal();
      await this.agent.refresh();
    }
  }

  async unarchiveDimensionValue() {
    const {model} = await this.store.post(
      this.editingDimensionValue.link('unarchive'),
      types.TIME_TRACKING.DIMENSION_VALUE
    );

    if (model) {
      this.closeUnarchiveDimensionValueModal();
      await this.agent.refresh();
    }
  }

  customLinksForDimensionValue(dimensionValue) {
    const links = [];

    if (dimensionValue.hasLink('archive')) {
      links.push({
        order: 0,
        text: 'time_tracking.dimensions.directory.Archive',
        action: value => this.openArchiveDimensionValueModal(value)
      });
    }

    if (dimensionValue.hasLink('unarchive')) {
      links.push({
        order: 0,
        text: 'time_tracking.dimensions.directory.Unarchive',
        action: value => this.openUnarchiveDimensionValueModal(value)
      });
    }

    return links;
  }
}

export default DimensionPanelState;
